import * as React from 'react';
import { SyntheticEvent } from 'react';

interface Props {
    labelText: string;
    invalidText: string;
    id: string;
    name: string;
    value?: string;
    onChange?: (name: string, value: string) => void;
    disabled?: boolean;
    maxLength?: number;
    pattern?: string;
    placeholder?: string;
    boldTitle?: boolean;
}

const ProfilePageInput = (props: Props) => {
    return (
        <div className="profile-page-input">
            <label htmlFor={props.id} className={props.boldTitle ? 'bold-profile-page-label' : ''}>
                {props.labelText}
            </label>
            <input
                id={props.id}
                name={props.name}
                value={props.value ? props.value : ''}
                onChange={(e: SyntheticEvent<HTMLInputElement>) =>
                    props.onChange && props.onChange(props.name, e.currentTarget.value.toString())
                }
                className="form-control"
                disabled={!!props.disabled}
                maxLength={props.maxLength}
                required={true}
                pattern={props.pattern}
                placeholder={props.placeholder}
            />
            {props.invalidText && (
                <div className="invalid-feedback profile-page-invalid-text">
                    {props.invalidText}
                </div>
            )}
        </div>
    );
};

export default ProfilePageInput;



// WEBPACK FOOTER //
// ./src/components/common/form/ProfilePageInput.tsx